import { useEffect } from "react";

export default function ScrollToTop(pathname) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
